import { render, staticRenderFns } from "./ApnAreaMarinaProtegida.vue?vue&type=template&id=6a53f72c&lang=pug"
import script from "./ApnAreaMarinaProtegida.vue?vue&type=script&lang=js"
export * from "./ApnAreaMarinaProtegida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports